import React, { useEffect, useRef } from "react";
import { isNullOrWhiteSpace } from "../../shared/string";

export type CustomHtmlRendererProps = {
  external?: boolean;
  scriptContent?: {
    code?: string;
  };
  scriptUrl?: string;
  wrapperClassNames?: string;
};

const CustomHtmlRenderer = ({
  external,
  scriptContent,
  scriptUrl,
  wrapperClassNames = ""
}: CustomHtmlRendererProps) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      if (external) {
        if (!isNullOrWhiteSpace(scriptUrl)) {
          const script = document.createElement("script");
          script.src = scriptUrl;
          script.async = true;

          const storedRef = ref.current;

          storedRef.appendChild(script);

          return () => {
            if (storedRef && !!script.parentNode) {
              storedRef.removeChild(script);
            }
          };
        }
      } else {
        if (!isNullOrWhiteSpace(scriptContent?.code)) {
          const range = document.createRange();
          const fragment = range.createContextualFragment(scriptContent!.code);

          const storedRef = ref.current;

          storedRef.appendChild(fragment);

          return () => {
            if (storedRef && !!fragment.parentNode) {
              storedRef.removeChild(fragment);
            }
          };
        }
      }
    }
  }, [external, scriptContent, scriptUrl]);

  return <div className={wrapperClassNames} ref={ref}></div>;
};

export default CustomHtmlRenderer;
